"use strict";

var _createForOfIteratorHelper = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collider = void 0;

var Enums_1 = require("../../Enums");

var Utils_1 = require("../../Utils");

function bounce(p1, p2) {
  Utils_1.Utils.circleBounce(Utils_1.Utils.circleBounceDataFromParticle(p1), Utils_1.Utils.circleBounceDataFromParticle(p2));
}

function destroy(p1, p2) {
  if (p1.getRadius() === undefined && p2.getRadius() !== undefined) {
    p1.destroy();
  } else if (p1.getRadius() !== undefined && p2.getRadius() === undefined) {
    p2.destroy();
  } else if (p1.getRadius() !== undefined && p2.getRadius() !== undefined) {
    if (p1.getRadius() >= p2.getRadius()) {
      p2.destroy();
    } else {
      p1.destroy();
    }
  }
}

var Collider = /*#__PURE__*/function () {
  function Collider(container) {
    _classCallCheck(this, Collider);

    this.container = container;
  }

  _createClass(Collider, [{
    key: "isEnabled",
    value: function isEnabled(particle) {
      return particle.particlesOptions.collisions.enable;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact(p1) {
      var container = this.container;
      var pos1 = p1.getPosition();
      var query = container.particles.quadTree.queryCircle(pos1, p1.getRadius() * 2);

      var _iterator = _createForOfIteratorHelper(query),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p2 = _step.value;

          if (p1 === p2 || !p2.particlesOptions.collisions.enable || p1.particlesOptions.collisions.mode !== p2.particlesOptions.collisions.mode || p2.destroyed || p2.spawning) {
            continue;
          }

          var pos2 = p2.getPosition();
          var dist = Utils_1.NumberUtils.getDistance(pos1, pos2);
          var radius1 = p1.getRadius();
          var radius2 = p2.getRadius();
          var distP = radius1 + radius2;

          if (dist <= distP) {
            this.resolveCollision(p1, p2);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "resolveCollision",
    value: function resolveCollision(p1, p2) {
      switch (p1.particlesOptions.collisions.mode) {
        case Enums_1.CollisionMode.absorb:
          {
            this.absorb(p1, p2);
            break;
          }

        case Enums_1.CollisionMode.bounce:
          {
            bounce(p1, p2);
            break;
          }

        case Enums_1.CollisionMode.destroy:
          {
            destroy(p1, p2);
            break;
          }
      }
    }
  }, {
    key: "absorb",
    value: function absorb(p1, p2) {
      var container = this.container;
      var fps = container.options.fpsLimit / 1000;

      if (p1.getRadius() === undefined && p2.getRadius() !== undefined) {
        p1.destroy();
      } else if (p1.getRadius() !== undefined && p2.getRadius() === undefined) {
        p2.destroy();
      } else if (p1.getRadius() !== undefined && p2.getRadius() !== undefined) {
        if (p1.getRadius() >= p2.getRadius()) {
          var factor = Utils_1.NumberUtils.clamp(p1.getRadius() / p2.getRadius(), 0, p2.getRadius()) * fps;
          p1.size.value += factor;
          p2.size.value -= factor;

          if (p2.getRadius() <= container.retina.pixelRatio) {
            p2.size.value = 0;
            p2.destroy();
          }
        } else {
          var _factor = Utils_1.NumberUtils.clamp(p2.getRadius() / p1.getRadius(), 0, p1.getRadius()) * fps;

          p1.size.value -= _factor;
          p2.size.value += _factor;

          if (p1.getRadius() <= container.retina.pixelRatio) {
            p1.size.value = 0;
            p1.destroy();
          }
        }
      }
    }
  }]);

  return Collider;
}();

exports.Collider = Collider;